import type { ADMIN_MFA_ERROR_CODES } from './validation/adminMfa.js'

export const OPERATIONS_DOMAINS = ['checkout', 'opening'] as const

/** Boutiques maximum par abonnement `operations:subscribe` ; au-delà, le serveur refuse l'abonnement. */
export const MAX_OPERATIONS_STORES = 100

export type OperationsDomain = (typeof OPERATIONS_DOMAINS)[number]

export interface OperationsSubscription {
  storeIds: number[]
  domains: OperationsDomain[]
}

export type OperationsSubscriptionError = 'internal-error' | 'invalid-payload' | 'too-many-stores'

export interface OperationsSubscriptionAck {
  subscribedStoreIds: number[]
  rejectedStoreIds: number[]
  error?: OperationsSubscriptionError
}

export const CHECKOUT_UPDATE_REASONS = [
  'computed',
  'validated',
  'cancelled',
  'stolen',
  'paid',
  'manual-mode',
  'kiosk-sync',
] as const

export type CheckoutUpdateReason = (typeof CHECKOUT_UPDATE_REASONS)[number]

export interface CheckoutUpdatedEvent {
  storeId: number
  kioskId: number | null
  cartId: number | null
  reason: CheckoutUpdateReason
  occurredAt: string
}

export interface OpeningEventUpdatedEvent {
  storeId: number
  occurredAt: string
}

/**
 * Annonce, juste avant leur déconnexion par le serveur, de la fermeture des sockets d'un admin sur
 * chacun de ses namespaces (`/`, `/operations`) : la déconnexion seule (`io server disconnect`) ne
 * dit pas pourquoi. `mfa_enrollment_required` : double facteur obligatoire, seul l'enrôlement reste
 * ouvert (code du refus HTTP).
 */
export const REALTIME_SESSION_CLOSED_EVENT = 'session:closed'

export type RealtimeSessionCloseCode = (typeof ADMIN_MFA_ERROR_CODES)['enrollmentRequired']

export interface RealtimeSessionClosedEvent {
  code: RealtimeSessionCloseCode
}

export interface OperationsServerToClientEvents {
  'checkout:updated': (event: CheckoutUpdatedEvent) => void
  'opening-event-updated': (event: OpeningEventUpdatedEvent) => void
  [REALTIME_SESSION_CLOSED_EVENT]: (event: RealtimeSessionClosedEvent) => void
}

export interface OperationsClientToServerEvents {
  'operations:subscribe': (
    subscription: OperationsSubscription,
    acknowledge: (ack: OperationsSubscriptionAck) => void,
  ) => void
  'operations:unsubscribe': (
    subscription: OperationsSubscription,
    acknowledge: (ack: OperationsSubscriptionAck) => void,
  ) => void
}
